// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import { Box, Typography } from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_user/account/services/basis',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services/basis',
  });

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={'space-between'}
        mb={2}
      >
        <Typography variant="h6" gutterBottom>
          {t('services.basis.title')}
        </Typography>
        <ServiceActivationSwitch
          managedAccountId={accountId}
          servicePath="basis"
          ariaLabel={t('services.basis.title')}
        />
      </Box>

      <Typography variant="body1">{t('services.basis.description')}</Typography>
    </Box>
  );
}

